module.exports = __webpack_public_path__ + "img/65400.5b343eb1.jpg";